import React from "react";

const Form = (props) => {
    const { heading } = props;
    return (
        <div className="form-container">
            <form className="form-element">
                <h3 className="form-header">{heading}</h3>
                {props.children}
            </form>
        </div>
    )
}

export default Form;